export const PageHeader = ({ title, subtitle, children }) => (
  <div className="mb-6 flex flex-wrap items-end justify-between gap-4 fade-up">
    <div>
      <h1 className="text-2xl font-extrabold tracking-tight text-[#0B1523] sm:text-3xl">{title}</h1>
      {subtitle && <p className="mt-1 text-sm text-slate-500">{subtitle}</p>}
    </div>
    <div className="flex flex-wrap items-center gap-2">{children}</div>
  </div>
);

export const GstBadge = ({ on }) => (
  <span
    className={`inline-flex rounded px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wide ${
      on ? "bg-teal-50 text-teal-700" : "bg-amber-50 text-amber-700"
    }`}
  >
    {on ? "GST 10%" : "GST Free"}
  </span>
);

const STATUS = {
  draft: "bg-slate-100 text-slate-700",
  sent: "bg-blue-50 text-blue-700",
  accepted: "bg-emerald-50 text-emerald-700",
  declined: "bg-red-50 text-red-700",
};

export const StatusPill = ({ status }) => (
  <span className={`inline-flex rounded-full px-2 py-0.5 text-xs font-semibold capitalize ${STATUS[status]}`}>{status}</span>
);
